const prefix = '/notifications';

export const routes = {
  LIST: prefix,
};
